import { inject, Injectable } from '@angular/core';
import {  ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorage } from '../_api/localstorage';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard   {

  constructor(private router : Router) { 

  }

  canActivate(router, state: RouterStateSnapshot) {
       //  return true;
  
    if (LocalStorage.AccessToken != null && LocalStorage.AccessToken.access_token != null) {

    
     
      return true;
    }
    else{
     // debugger;
      this.router.navigate(['/login'], {queryParams : {returnUrl : state.url}});
      return false;
    }
  }
}

